import { Box } from "@chakra-ui/react";
import * as React from "react";

function FranchisePreview() {
  return (
    <Box>
    </Box>
  );
}

export default FranchisePreview;